module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('h3', [_vm._v("Turno atual "), _c('small', [_vm._v(_vm._s(_vm.turnoAtual.nometurno) + " das " + _vm._s(_vm.turnoAtual.horainicio) + " às " + _vm._s(_vm.turnoAtual.horafim) + " com tempo útil de " + _vm._s(_vm.turnoAtual.tempoutil) + "h")])])])]), _vm._v(" "), (!_vm.detalhar) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.monitores), function(monitor) {
    return _c('div', {
      key: monitor.id,
      staticClass: "col-md-4"
    }, [(monitor.atualizado === _vm.dia) ? _c('h4', [_vm._v(_vm._s(monitor.nomemaquina) + " - Uso (%)")]) : _c('h4', [_vm._v(_vm._s(_vm.buscarMonitorAtual()) + "Atualizar Página para - {dia}}")]), _vm._v(" "), _c('h5', [_vm._v("Velocidade: " + _vm._s(monitor.velocidade) + " (cx/h)")]), _vm._v(" "), _c('va-chart', {
      attrs: {
        "chart-config": monitor.chartConfig
      }
    })], 1)
  }), 0)])])]) : _vm._e(), _vm._v(" "), (!_vm.detalhar) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.monitores), function(monitor) {
    return _c('div', {
      key: monitor.id,
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "box box-success"
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('h4', {
      staticClass: "box-title"
    }, [_vm._v(_vm._s(monitor.nomemaquina) + " - Produção")]), _vm._v(" "), _vm._m(0, true)]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('table', {
      staticClass: "table table-condensed"
    }, [_vm._m(1, true), _vm._v(" "), _vm._l((monitor.extraNovo), function(extra, index) {
      return _c('tr', {
        key: extra.id
      }, [_c('td', [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.SegToMili(extra.duracao)))]), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "badge bg-green"
      }, [_vm._v(_vm._s(extra.total))])]), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "badge bg-red"
      }, [_vm._v(_vm._s(extra.perdas))])])])
    })], 2)])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.monitores), function(monitor) {
    return _c('div', {
      key: monitor.id,
      staticClass: "col-md-4",
      on: {
        "click": function($event) {
          return _vm.detalharMaquina(monitor.idcontrolador, monitor.nomemaquina, monitor.Acionamentos)
        }
      }
    }, [(monitor.valorfuncao !== 0) ? _c('div', {
      staticClass: "small-box bg-yellow"
    }, [_c('div', {
      staticClass: "inner"
    }, [(!_vm.detalhar) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(monitor.textofuncao))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(monitor.nomemaquina))]), _vm._v(" "), (!_vm.detalhar) ? _c('span', {
      staticClass: "info-box-text"
    }, [_c('small', [_vm._v(_vm._s(_vm.ajustarData(monitor.updated_at)))])]) : _vm._e(), _vm._v(" "), (_vm.detalhar) ? _c('div', [_c('p', [_vm._v("Operando: " + _vm._s(monitor.horasoperando))]), _vm._v(" "), _c('p', [_vm._v("Em Função: " + _vm._s(monitor.horasfuncao))]), _vm._v(" "), _c('p', [_vm._v("Parado s/ Ordem: " + _vm._s(monitor.horasDisponivelSemOrdem))]), _vm._v(" "), _c('p', [_vm._v("Parado c/ Ordem: " + _vm._s(monitor.horasDisponivelComOrdem))]), _vm._v(" "), _c('p', [_vm._v("Disponível: " + _vm._s(monitor.horasdisponivel))])]) : _vm._e()]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), (!_vm.detalhar) ? _c('div', {
      staticClass: "small-box-footer"
    }, [_vm._v("\n          Mais informações "), _c('i', {
      staticClass: "fa fa-arrow-circle-right"
    })]) : _vm._e()]) : (monitor.isoperando !== 0) ? _c('div', {
      staticClass: "small-box bg-green"
    }, [_c('div', {
      staticClass: "inner"
    }, [(!_vm.detalhar) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(monitor.textostatus))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(monitor.nomemaquina))]), _vm._v(" "), (!_vm.detalhar) ? _c('span', {
      staticClass: "info-box-text"
    }, [_c('small', [_vm._v(_vm._s(_vm.ajustarData(monitor.updated_at)))])]) : _vm._e(), _vm._v(" "), (_vm.detalhar) ? _c('div', [_c('p', [_vm._v("Operando: " + _vm._s(monitor.horasoperando))]), _vm._v(" "), _c('p', [_vm._v("Em Função: " + _vm._s(monitor.horasfuncao))]), _vm._v(" "), _c('p', [_vm._v("Parado s/ Ordem: " + _vm._s(monitor.horasDisponivelSemOrdem))]), _vm._v(" "), _c('p', [_vm._v("Parado c/ Ordem: " + _vm._s(monitor.horasDisponivelComOrdem))]), _vm._v(" "), _c('p', [_vm._v("Disponível: " + _vm._s(monitor.horasdisponivel))])]) : _vm._e()]), _vm._v(" "), _vm._m(3, true), _vm._v(" "), (!_vm.detalhar) ? _c('div', {
      staticClass: "small-box-footer"
    }, [_vm._v("\n          Mais informações "), _c('i', {
      staticClass: "fa fa-arrow-circle-right"
    })]) : _vm._e()]) : _c('div', {
      staticClass: "small-box bg-aqua"
    }, [_c('div', {
      staticClass: "inner"
    }, [(!_vm.detalhar) ? _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(monitor.textostatus))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(monitor.nomemaquina))]), _vm._v(" "), (!_vm.detalhar) ? _c('span', {
      staticClass: "info-box-text"
    }, [_c('small', [_vm._v(_vm._s(_vm.ajustarData(monitor.updated_at)))])]) : _vm._e(), _vm._v(" "), (_vm.detalhar) ? _c('div', [_c('p', [_vm._v("Operando: " + _vm._s(monitor.horasoperando))]), _vm._v(" "), _c('p', [_vm._v("Em Função: " + _vm._s(monitor.horasfuncao))]), _vm._v(" "), _c('p', [_vm._v("Parado s/ Ordem: " + _vm._s(monitor.horasDisponivelSemOrdem))]), _vm._v(" "), _c('p', [_vm._v("Parado c/ Ordem: " + _vm._s(monitor.horasDisponivelComOrdem))]), _vm._v(" "), _c('p', [_vm._v("Disponível: " + _vm._s(monitor.horasdisponivel))])]) : _vm._e()]), _vm._v(" "), _vm._m(4, true), _vm._v(" "), (!_vm.detalhar) ? _c('div', {
      staticClass: "small-box-footer"
    }, [_vm._v("\n          Mais informações "), _c('i', {
      staticClass: "fa fa-arrow-circle-right"
    })]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detalhar),
      expression: "detalhar"
    }],
    staticClass: "col-sm-1"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.detalhar = false
      }
    }
  }, [_vm._v("Voltar")])])])]), _vm._v(" "), (_vm.detalhar) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('h2', [_vm._v("Registros da Máquina")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.detalhes.texto))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('paginate', {
    staticClass: "paginate-list",
    attrs: {
      "name": "dados",
      "list": _vm.dados,
      "per": 5
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("Data Inicio")]), _vm._v(" "), _c('th', [_vm._v("Data Fim")]), _vm._v(" "), _c('th', [_vm._v("Legenda")]), _vm._v(" "), _c('th', [_vm._v("TAG/Cód")]), _vm._v(" "), _c('th', [_vm._v("Extra")]), _vm._v(" "), _c('th', [_vm._v("Ação")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginated('dados')), function(detalhe) {
    return _c('tr', {
      key: detalhe.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(detalhe.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.updated_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.textolegenda))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.tag))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(detalhe.extra))]), _vm._v(" "), _c('td', [_c('div', [(detalhe.isinicial === 1) ? _c('span', {
      staticClass: "badge bg-aqua"
    }, [_vm._v("Iniciado")]) : (detalhe.isfuncao === 1) ? _c('span', {
      staticClass: "badge bg-yellow"
    }, [_vm._v("Função")]) : (detalhe.isoperando === 1) ? _c('span', {
      staticClass: "badge bg-green"
    }, [_vm._v("Operando")]) : _c('span', {
      staticClass: "badge bg-aqua"
    }, [_vm._v("Sem Produção")])])])])
  }), 0)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('paginate-links', {
    attrs: {
      "for": "dados",
      "limit": 5,
      "show-step-links": true,
      "id": "paginacao"
    }
  })], 1)])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Tag/Cód")]), _vm._v(" "), _c('th', [_vm._v("Duração")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("Qtd")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("Perdas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-industry"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-start"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f566759c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Dashboard.vue
// module id = 639
// module chunks = 1